import React from 'react';
import { fromJS, Map } from 'immutable';
import shallowCompare from '../../lib/shallowCompare';
import Modal from '../../../client/components/Modal';
import styles from './index.sass';
import menuClosePng from '../images/button_menu_close.png';
import menuCloseSvg from '../images/button_menu_close.svg';
import banquetLogoPng from '../images/banquet_logo_2x.png';
import banquetLogoSvg from '../images/banquet_logo.svg';

class MarketingRegisterModal extends React.Component {
  static propTypes = {
    email: React.PropTypes.string,
    plan: React.PropTypes.string,
    onClose: React.PropTypes.func.isRequired
  };

  static contextTypes = {
    getUserAgent: React.PropTypes.func
  };

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      success: false,
      error: null,
      formData: fromJS({
        contact_email: props.email || null,
        contact_phone: null,
        contact_name: null,
        store_name: null,
        store_website: null,
        store_address: {
          street: null,
          city: null,
          state: null
        }
      }),
      invalidFields: fromJS({
        contact_email: false,
        contact_phone: false,
        contact_name: false,
        store_name: false,
        store_website: false,
        store_address: {
          street: false,
          city: false,
          state: false
        }
      })
    };
  }

  componentDidMount() {
    document.body.style.overflow = 'hidden';
    if(this.context.getUserAgent().isMobile) {
      document.body.style.width = '100%';
      document.body.style.position = 'fixed';
    }
  }

  componentWillUnmount() {
    document.body.style.overflow = '';
    if(this.context.getUserAgent().isMobile) {
      document.body.style.width = '';
      document.body.style.position = '';
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }

  handleOnSubmitContactForm(e) {
    e.stopPropagation();
    e.preventDefault();

    this.setState({loading: true});

    let invalidFields = new Map();
    let payload = this.state.formData.toJS();

    payload.source = location.origin + location.pathname;
    payload.plan = this.props.plan;

    if(!payload.contact_email || !payload.contact_email.match(/.@./)) {
      invalidFields = invalidFields.set('contact_email', true);
    }
    if(!payload.contact_name) {
      invalidFields = invalidFields.set('contact_name', true);
    }
    if(!payload.store_name) {
      invalidFields = invalidFields.set('store_name', true);
    }

    if(invalidFields.size) {
      this.setState({invalidFields: invalidFields, loading: false});
      return;
    }

    let data = {payload};
    let xhr = new XMLHttpRequest();
    xhr.open('POST', 'https://zapier.com/hooks/catch/2yp3uw/');
    xhr.onload = () => {
      if(xhr.status === 200) {
        this.setState({success: true, loading: false});
      } else {
        this.setState({error: true, loading: false});
        let response = JSON.parse(xhr.response);
        if(response.error && typeof Bugsnag !== 'undefined') {
          Bugsnag.notifyException(response.error, response.error.name || 'Error', data);
        }
      }
    };
    xhr.onerror = (error) => {
      this.setState({error: true, loading: false});
      if(error && typeof Bugsnag !== 'undefined') {
        Bugsnag.notifyException(error, error.name || 'Error', data);
      }
    };
    xhr.send(JSON.stringify(data));
  }

  handleOnChangeInput(field, e) {
    if(-1 !== ['city', 'state'].indexOf(field)) {
      this.setState({formData: this.state.formData.setIn(['store_address', field], e.target.value)});
    } else {
      this.setState({formData: this.state.formData.set(field, e.target.value)});
    }
  }

  handleOnCloseModal() {
    this.props.onClose();
  }

  render() {
   let modalProps = {
     onClose: this.handleOnCloseModal.bind(this),
     closeOnOutsideClick: true,
     className: styles.marketingRegisterModal
   };
   let { formData, invalidFields, success, error } = this.state;
   let contactFormClasses = styles.contactForm;
   if(success) {
     contactFormClasses = styles.contactFormSent;
   } else if(error) {
     contactFormClasses = styles.contactFormFailed;
   }
    return (
      <Modal {...modalProps}>
        <div className={contactFormClasses}>
          <button className={styles.closeButton} onClick={this.handleOnCloseModal.bind(this)}>
            <img src={menuClosePng} srcSet={menuCloseSvg} />
          </button>
          <img className={styles.banquetLogo} src={banquetLogoPng} srcSet={banquetLogoSvg} />
          <h3 className={styles.header}>Get started</h3>
          <p className={styles.subheader}>Fill out the form and we'll get back to you as soon as possible</p>
          <div className={styles.confirmation}>
            <p className={styles.confirmationTitle}>Thank you!</p>
            <p className={styles.confirmationMessage}>We'll get back to you shortly.</p>
          </div>
          <div className={styles.error}>
            <p className={styles.errorMessage}>There was an error processing your request. Please try again in a few moments.</p>
          </div>
          <form onSubmit={this.handleOnSubmitContactForm.bind(this)}>
            <label htmlFor="contact_name">Name</label>
            <input className={styles.input + (invalidFields.get('contact_name') ? ` ${styles.invalid}` : '')} onChange={this.handleOnChangeInput.bind(this, 'contact_name')} value={formData.get('contact_name')} type="text" placeholder="Your full name" id="contact_name" name="contact_name" required />
            <label htmlFor="contact_phone">Phone Number</label>
            <input className={styles.input + (invalidFields.get('contact_phone') ? ` ${styles.invalid}` : '')} onChange={this.handleOnChangeInput.bind(this, 'contact_phone')} value={formData.get('contact_phone')} type="text" placeholder="Your phone number" id="contact_phone" name="contact_phone" />
            <label htmlFor="contact_email">Email Address</label>
            <input className={styles.input + (invalidFields.get('contact_email') ? ` ${styles.invalid}` : '')} onChange={this.handleOnChangeInput.bind(this, 'contact_email')} value={formData.get('contact_email')} type="email" placeholder="Your email address" id="contact_email" name="contact_email" required />
            <label htmlFor="store_name">Company</label>
            <input className={styles.input + (invalidFields.get('store_name') ? ` ${styles.invalid}` : '')} onChange={this.handleOnChangeInput.bind(this, 'store_name')} value={formData.get('store_name')} type="text" placeholder="Your business name" id="store_name" name="store_name" required />
            <label htmlFor="store_website">Website</label>
            <input className={styles.input + (invalidFields.get('store_website') ? ` ${styles.invalid}` : '')} onChange={this.handleOnChangeInput.bind(this, 'store_website')} value={formData.get('store_website')} type="text" placeholder="Optional" id="store_website" name="store_website" />
            <label htmlFor="store_address_city">City</label>
            <input className={styles.input + (invalidFields.getIn(['store_address', 'city']) ? ` ${styles.invalid}` : '')} onChange={this.handleOnChangeInput.bind(this, 'city')} value={formData.get('city')} type="text" placeholder="City" id="store_address_city" name="store_address_city" />
            <label htmlFor="store_address_state">State</label>
            <input className={styles.input + (invalidFields.getIn(['store_address', 'state']) ? ` ${styles.invalid}` : '')} onChange={this.handleOnChangeInput.bind(this, 'state')} value={formData.get('state')} type="text" placeholder="State" id="store_address_state" name="store_address_state" />
            <button className={styles.submitContactFormButton} disabled={this.state.loading}>Get started</button>
          </form>
        </div>
      </Modal>
    );
  }
}

export default MarketingRegisterModal;



// WEBPACK FOOTER //
// banquet/components/MarketingRegisterModal/index.js